
let SERVER_URL = process.env.REACT_APP_API_URL;
const getToken = () => {
    return JSON.parse(localStorage.getItem("key"));
};
const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "",
};
const getUserId = () => {
    return Number(localStorage.getItem("userId"));
  };

export const getUserSkills = (id) => {
    const endpoint = `api/group/user/skills/${id}`;
    const url = SERVER_URL + endpoint;
    return fetch(url, {
      method: "GET",
      headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    })
      .then((res) => res.json())
      .then((data) => data);
  };
  export const httpSelectUserIdBySkill = (id) => {
    const endpoint = `api/group/user/select/userSkill/${id}`;
    const url = SERVER_URL + endpoint;
    return fetch(url, {
      method: "GET",
      headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    })
      .then((res) => res.json())
      .then((data) => data);
  };
 
  export const httpCreateUserGroup = (data) => {
   //console.log(data);return false;
    const endpoint = "api/group/user/groupskill/create";
    const url = SERVER_URL + endpoint;
    return fetch(url, {
      method: "POST",
      headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
      body: JSON.stringify({
        user_id:data.user_id?data.user_id:getUserId(),
        skill_id:data.skillData?data.skillData: data,
        created_by: getUserId(),
        created_on: new Date(),
      }),
    })
      .then((res) => res.json())
      .then((data) => data);
  };
  export const httpSelectUserSkill = () => {
    //console.log(data)
    const loginUser = getUserId();
     const endpoint = `api/group/user/select/userSkill/${loginUser}`;
     const url = SERVER_URL + endpoint;
     return fetch(url, {
       method: "GET",
       headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
     })
       .then((res) => res.json())
       .then((data) => data);
   };